import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=3d6aab31&scoped=true&"
import script from "./Legacy.vue?vue&type=script&lang=js&"
export * from "./Legacy.vue?vue&type=script&lang=js&"
import style0 from "./Legacy.vue?vue&type=style&index=0&id=3d6aab31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6aab31",
  null
  
)

export default component.exports